import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get language from localStorage or default to English
    return localStorage.getItem('appLanguage') || 'en';
  });

  useEffect(() => {
    // Save language preference to localStorage
    localStorage.setItem('appLanguage', language);
  }, [language]);

  useEffect(() => {
    // Listen for storage changes (e.g., from login)
    const handleStorageChange = () => {
      const newLanguage = localStorage.getItem('appLanguage');
      if (newLanguage && newLanguage !== language) {
        console.log('Language context updating from', language, 'to', newLanguage);
        setLanguage(newLanguage);
      }
    };

    // Listen for custom events dispatched after login or language change
    window.addEventListener('localStorageUpdated', handleStorageChange);
    window.addEventListener('languageChanged', handleStorageChange);
    
    return () => {
      window.removeEventListener('localStorageUpdated', handleStorageChange);
      window.removeEventListener('languageChanged', handleStorageChange);
    };
  }, [language]);

  const changeLanguage = (lang) => {
    setLanguage(lang);
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key; // Return key if translation not found
      }
    }
    
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

